// @flow

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';
import { validateCustomerEmail } from '@tectonics/prs/customer/validation/customer-email';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'selectedVirtualAccountBank':
      return onlyWhen('display_virtual_account_bank_list') && validateVirtualAccountBank(userInputValue);

    case 'customerEmail':
      return onlyWhen('field_indonesia_customer_email') && validateCustomerEmail(userInputValue);

    default:
      return VALID;
  }
}

function validateVirtualAccountBank(bankCode?: string): ?UserInputValidationError {
  if (!bankCode || bankCode.trim() === '')
    return { id: 'empty' };

  return VALID;
}
